// extracted by mini-css-extract-plugin
export default {"editIamge":"style_editIamge__X+lV1","changePasswordModal":"style_changePasswordModal__nzo9T","formGroup":"style_formGroup__elQUJ","PrfileIamge":"style_PrfileIamge__xUPOu"};